import { Button } from '@akin-home/buttons/native';
import { convertToNon24HourFormat } from '@akin-home/dates';
import { Text } from '@akin-home/text/native';
import styled from 'styled-components/native';
import Dialog, { DialogProps } from '../Dialog/Dialog';

interface Props extends DialogProps {
  value?: string;
  onSelect(hour: string): void;
}

export const SelectHourDialog = ({ value, onSelect, ...rest }: Props) => {
  return (
    <Dialog size="lg" {...rest}>
      <Body>
        <Text variant="h3" weight="semibold">
          Choose hour
        </Text>
        <Row>
          {hours.slice(0, 8).map((hour) => (
            <HourButton
              key={hour}
              hour={hour}
              selected={value === hour}
              onPress={onSelect}
            />
          ))}
        </Row>
        <Row>
          {hours.slice(8, 16).map((hour) => (
            <HourButton
              key={hour}
              hour={hour}
              selected={value === hour}
              onPress={onSelect}
            />
          ))}
        </Row>
        <Row>
          {hours.slice(16, 24).map((hour) => (
            <HourButton
              key={hour}
              hour={hour}
              selected={value === hour}
              onPress={onSelect}
            />
          ))}
        </Row>
      </Body>

      <Bottom>
        <Button variant="text" onPress={rest.onClose}>
          Cancel
        </Button>
      </Bottom>
    </Dialog>
  );
};

const HourButton = ({
  hour,
  selected,
  onPress,
}: {
  hour: string;
  selected?: boolean;
  onPress(hour: string): void;
}) => {
  const press = () => onPress(hour);

  const suffix = hour < '12' ? 'am' : 'pm';

  return (
    <StyledHourButton
      variant={selected ? 'primary' : 'secondary'}
      onPress={press}
    >
      {parseInt(convertToNon24HourFormat(hour))} {suffix}
    </StyledHourButton>
  );
};

export const Body = styled.View`
  padding: 30px;
  padding-top: 15px;
  gap: 15px;
  align-items: center;
`;

export const Row = styled.View`
  flex-direction: row;
  gap: 15px;
`;

export const Bottom = styled.View`
  flex-direction: row;
  padding: 10px 32px;

  border-top-width: 1px;
  border-top-color: lightgrey;
`;

export const StyledHourButton = styled(Button)`
  width: 80px;
`;

const hours = [...Array(24)].map((_, idx) => idx.toString().padStart(2, '0'));
